import { FC } from 'react';
import Head from 'next/head';

interface StyleLinkingProp {
  'data-style-id': string;
}

export interface ScopedStyleProps {
  id: string;
  css: string;
  renderItem: (props: StyleLinkingProp) => React.JSX.Element;
}

export const ScopedStyle: FC<ScopedStyleProps> = ({ id, css, renderItem }) => {
  return (
    <>
      <Head>
        <style>{`[data-style-id="${id}"]${css}`}</style>
      </Head>
      {renderItem({ ['data-style-id']: id })}
    </>
  );
};
